module.exports = __webpack_public_path__ + "static/media/EMS UX Research Catalog 2007-2021.22e94332.xlsx";